import { useState, useEffect, useContext } from 'react'
import _ from "lodash"

import Typography from '@mui/material/Typography'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import { searchAppleAppstore } from '/providers/templates-api'
import { PassContext } from '../pass-context'
import { AppContext } from '/providers/app-context'

const PopupDialogLinkedApp = ({ open, close }) => {

  try {
    const { template, setTemplate } = useContext(PassContext)
    const { apiSource, apiKeys } = useContext(AppContext)

    const [newTemplate, setNewTemplate] = useState({})
    const [appList, setAppList] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [countryCode, setCountryCode] = useState("gb")
    const [selectedApp, setSelectedApp] = useState()

    useEffect(() => {
      try {
        if (open) {
          setNewTemplate(_.cloneDeep(template))
        }
      }
      catch (err) {
        throw err
      }
    }, [open])

    const search = async () => {
      try {
        const result = await searchAppleAppstore({apiSource, apiKeys, countryCode,searchTerm})
        const apps = result.apps.filter(i => i.primaryGenreName !== "Games")

        setSelectedApp(apps[0])
        setAppList(apps)
      }
      catch (err) {
        console.error(err)
      }
    }

    const searchEnterKey = e => {
      if (e.code === "Enter") search()
    }

    const removeLinkedApp = () => {
      let t = _.cloneDeep(newTemplate)
      delete t.meta.appLink
      setNewTemplate(t)
    }

    const handleClose = (e, reason) => {
      if (reason && reason === "backdropClick")
        return
      close()
    }

    const assignSelectedApp = () => {
      let selectedAppEssentialData = {
        id: selectedApp.trackId,
        seller: selectedApp.sellerName,
        title: selectedApp.trackName,
        icon: selectedApp.artworkUrl60
      }

      let t = _.cloneDeep(newTemplate)
      t.meta.appLink = selectedAppEssentialData
      setNewTemplate(t)
    }

    const save = () => {
      if (!_.isEqual(newTemplate,template)) setTemplate(newTemplate)
      close()
    }

    if (open) return (
      <Dialog onClose={handleClose} open={open} sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "600px",
            maxWidth: "600px",
          },
        },
      }}>

        <div className="popupFieldEditor" style={{ width: 600 }}>

          <Typography variant="h3" sx={{ p: 2 }}>
            Linked Application
          </Typography>

          <Box
            sx={{ '& .MuiTextField-root': { m: 1, width: '420px' } }}
          >
            {newTemplate.meta?.appLink &&
              <div>
                <Typography variant="h6" sx={{ p: 2 }}>
                  Selected application
                </Typography>
                <div className="flex flex-row gap-5">
                  <div className="flex-grow">
                    <LinkedApp newTemplate={newTemplate} />
                  </div>
                  <Button onClick={removeLinkedApp} variant="outlined" sx={{ height: 40 }}>Remove</Button>
                </div>
              </div>
            }

            <Typography variant="h6" sx={{ p: 2 }}>
              Search for an application
            </Typography>

            <Select
              value={countryCode}
              className="popupEditorMenuItem"
              onChange={e => setCountryCode(e.target.value)}>
              {countries.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}
            </Select>

            <div className="flex flex-row justify-between mb-10">
              <TextField value={searchTerm} onChange={e => setSearchTerm(e.target.value)} onKeyUp={searchEnterKey} />
              <Button onClick={search} variant="contained" style={{ height: 40, marginTop: 14 }}>Search</Button>
            </div>

            {appList.length > 0 &&
              <div className="flex flex-row gap-5 mb-10">
                <div className="flex-grow">
                  <Select
                    value={selectedApp}
                    className="popupEditorMenuItem"
                    onChange={e => setSelectedApp(e.target.value)}>
                    {appList.map(i => <MenuItem key={i.trackId} value={i}>
                      <div className="flex flex-row gap-3 mb-5">
                        <img src={i.artworkUrl60} />
                        <div className="flex flex-col gap-3">
                          <div>{i.sellerName}</div>
                          <div>{i.trackName}</div>
                        </div>
                      </div>
                    </MenuItem>)}
                  </Select>
                </div>
                <Button onClick={assignSelectedApp} variant="outlined" sx={{ height: 40 }}>Assign</Button>
              </div>
            }

            <hr />

            <div className="flex flex-row w-full justify-between">
              <div />
              <div className="flex flex-row-reverse gap-5">
                <Button variant="contained" onClick={save}>Save</Button>
                <Button variant="outlined" onClick={close}>Cancel</Button>
              </div>
            </div>

          </Box>
        </div>
      </Dialog>
    )
  }
  catch (err) {
    console.error(err)
  }
}

export default PopupDialogLinkedApp

const LinkedApp = ({ newTemplate }) => {

  if (newTemplate.meta?.appLink) return (
    <div className="flex flex-row gap-3 mb-5 p-4" style={{ border: "1px solid black" }}>
      <img src={newTemplate.meta.appLink.icon} />
      <div className="flex flex-col gap-3">
        <div>{newTemplate.meta.appLink.seller}</div>
        <div>{newTemplate.meta.appLink.title}</div>
      </div>
    </div>
  )

  return (
    <div>No app currently assigned</div>
  )
}


const countries = [
  {
    "id": "gb",
    "name": "United Kingdom"
  },
  {
    "id": "us",
    "name": "United States"
  },
  {
    "id": "al",
    "name": "Albania"
  },
  {
    "id": "dz",
    "name": "Algeria"
  },
  {
    "id": "ao",
    "name": "Angola"
  },
  {
    "id": "ai",
    "name": "Anguilla"
  },
  {
    "id": "ag",
    "name": "Antigua and Barbuda"
  },
  {
    "id": "ar",
    "name": "Argentina"
  },
  {
    "id": "am",
    "name": "Armenia"
  },
  {
    "id": "au",
    "name": "Australia"
  },
  {
    "id": "at",
    "name": "Austria"
  },
  {
    "id": "az",
    "name": "Azerbaijan"
  },
  {
    "id": "bs",
    "name": "Bahamas"
  },
  {
    "id": "bh",
    "name": "Bahrain"
  },
  {
    "id": "bb",
    "name": "Barbados"
  },
  {
    "id": "by",
    "name": "Belarus"
  },
  {
    "id": "be",
    "name": "Belgium"
  },
  {
    "id": "bz",
    "name": "Belize"
  },
  {
    "id": "bj",
    "name": "Benin"
  },
  {
    "id": "bm",
    "name": "Bermuda"
  },
  {
    "id": "bt",
    "name": "Bhutan"
  },
  {
    "id": "bo",
    "name": "Bolivia"
  },
  {
    "id": "bw",
    "name": "Botswana"
  },
  {
    "id": "br",
    "name": "Brazil"
  },
  {
    "id": "vg",
    "name": "British Virgin Islands"
  },
  {
    "id": "bn",
    "name": "Brunei Darussalam"
  },
  {
    "id": "bg",
    "name": "Bulgaria"
  },
  {
    "id": "bf",
    "name": "Burkina Faso"
  },
  {
    "id": "kh",
    "name": "Cambodia"
  },
  {
    "id": "ca",
    "name": "Canada"
  },
  {
    "id": "cv",
    "name": "Cape Verde"
  },
  {
    "id": "ky",
    "name": "Cayman Islands"
  },
  {
    "id": "td",
    "name": "Chad"
  },
  {
    "id": "cl",
    "name": "Chile"
  },
  {
    "id": "cn",
    "name": "China"
  },
  {
    "id": "co",
    "name": "Colombia"
  },
  {
    "id": "cg",
    "name": "Congo Republic of the"
  },
  {
    "id": "cr",
    "name": "Costa Rica"
  },
  {
    "id": "hr",
    "name": "Croatia"
  },
  {
    "id": "cy",
    "name": "Cyprus"
  },
  {
    "id": "cz",
    "name": "Czech Republic"
  },
  {
    "id": "dk",
    "name": "Denmark"
  },
  {
    "id": "dm",
    "name": "Dominica"
  },
  {
    "id": "do",
    "name": "Dominican Republic"
  },
  {
    "id": "ec",
    "name": "Ecuador"
  },
  {
    "id": "eg",
    "name": "Egypt"
  },
  {
    "id": "sv",
    "name": "El Salvador"
  },
  {
    "id": "ee",
    "name": "Estonia"
  },
  {
    "id": "fj",
    "name": "Fiji"
  },
  {
    "id": "fi",
    "name": "Finland"
  },
  {
    "id": "fr",
    "name": "France"
  },
  {
    "id": "gm",
    "name": "Gambia"
  },
  {
    "id": "de",
    "name": "Germany"
  },
  {
    "id": "gh",
    "name": "Ghana"
  },
  {
    "id": "gr",
    "name": "Greece"
  },
  {
    "id": "gd",
    "name": "Grenada"
  },
  {
    "id": "gt",
    "name": "Guatemala"
  },
  {
    "id": "gw",
    "name": "Guinea-Bissau"
  },
  {
    "id": "gy",
    "name": "Guyana"
  },
  {
    "id": "hn",
    "name": "Honduras"
  },
  {
    "id": "hk",
    "name": "Hong Kong"
  },
  {
    "id": "hu",
    "name": "Hungary"
  },
  {
    "id": "is",
    "name": "Iceland"
  },
  {
    "id": "in",
    "name": "India"
  },
  {
    "id": "id",
    "name": "Indonesia"
  },
  {
    "id": "ie",
    "name": "Ireland"
  },
  {
    "id": "il",
    "name": "Israel"
  },
  {
    "id": "it",
    "name": "Italy"
  },
  {
    "id": "jm",
    "name": "Jamaica"
  },
  {
    "id": "jp",
    "name": "Japan"
  },
  {
    "id": "jo",
    "name": "Jordan"
  },
  {
    "id": "kz",
    "name": "Kazakhstan"
  },
  {
    "id": "ke",
    "name": "Kenya"
  },
  {
    "id": "kr",
    "name": "Korea Republic Of"
  },
  {
    "id": "kw",
    "name": "Kuwait"
  },
  {
    "id": "kg",
    "name": "Kyrgyzstan"
  },
  {
    "id": "la",
    "name": "Lao People's Democratic Republic"
  },
  {
    "id": "lv",
    "name": "Latvia"
  },
  {
    "id": "lb",
    "name": "Lebanon"
  },
  {
    "id": "lr",
    "name": "Liberia"
  },
  {
    "id": "li",
    "name": "Liechtenstein"
  },
  {
    "id": "lt",
    "name": "Lithuania"
  },
  {
    "id": "lu",
    "name": "Luxembourg"
  },
  {
    "id": "mo",
    "name": "Macau"
  },
  {
    "id": "mk",
    "name": "Macedonia"
  },
  {
    "id": "mg",
    "name": "Madagascar"
  },
  {
    "id": "mw",
    "name": "Malawi"
  },
  {
    "id": "my",
    "name": "Malaysia"
  },
  {
    "id": "ml",
    "name": "Mali"
  },
  {
    "id": "mt",
    "name": "Malta"
  },
  {
    "id": "mr",
    "name": "Mauritania"
  },
  {
    "id": "mu",
    "name": "Mauritius"
  },
  {
    "id": "mx",
    "name": "Mexico"
  },
  {
    "id": "fm",
    "name": "Micronesia Federated States of"
  },
  {
    "id": "md",
    "name": "Moldova"
  },
  {
    "id": "mn",
    "name": "Mongolia"
  },
  {
    "id": "me",
    "name": "Montenegro"
  },
  {
    "id": "ms",
    "name": "Montserrat"
  },
  {
    "id": "mz",
    "name": "Mozambique"
  },
  {
    "id": "na",
    "name": "Namibia"
  },
  {
    "id": "np",
    "name": "Nepal"
  },
  {
    "id": "nl",
    "name": "Netherlands"
  },
  {
    "id": "nz",
    "name": "New Zealand"
  },
  {
    "id": "ni",
    "name": "Nicaragua"
  },
  {
    "id": "ne",
    "name": "Niger"
  },
  {
    "id": "ng",
    "name": "Nigeria"
  },
  {
    "id": "no",
    "name": "Norway"
  },
  {
    "id": "om",
    "name": "Oman"
  },
  {
    "id": "pk",
    "name": "Pakistan"
  },
  {
    "id": "pw",
    "name": "Palau"
  },
  {
    "id": "pa",
    "name": "Panama"
  },
  {
    "id": "pg",
    "name": "Papua New Guinea"
  },
  {
    "id": "py",
    "name": "Paraguay"
  },
  {
    "id": "pe",
    "name": "Peru"
  },
  {
    "id": "ph",
    "name": "Philippines"
  },
  {
    "id": "pl",
    "name": "Poland"
  },
  {
    "id": "pt",
    "name": "Portugal"
  },
  {
    "id": "qa",
    "name": "Qatar"
  },
  {
    "id": "ro",
    "name": "Romania"
  },
  {
    "id": "ru",
    "name": "Russia"
  },
  {
    "id": "sa",
    "name": "Saudi Arabia"
  },
  {
    "id": "sn",
    "name": "Senegal"
  },
  {
    "id": "sc",
    "name": "Seychelles"
  },
  {
    "id": "sl",
    "name": "Sierra Leone"
  },
  {
    "id": "sg",
    "name": "Singapore"
  },
  {
    "id": "sk",
    "name": "Slovakia"
  },
  {
    "id": "si",
    "name": "Slovenia"
  },
  {
    "id": "sb",
    "name": "Solomon Islands"
  },
  {
    "id": "za",
    "name": "South Africa"
  },
  {
    "id": "es",
    "name": "Spain"
  },
  {
    "id": "lk",
    "name": "Sri Lanka"
  },
  {
    "id": "kn",
    "name": "St. Kitts and Nevis"
  },
  {
    "id": "lc",
    "name": "St. Lucia"
  },
  {
    "id": "vc",
    "name": "St. Vincent and The Grenadines"
  },
  {
    "id": "sr",
    "name": "Suriname"
  },
  {
    "id": "sz",
    "name": "Swaziland"
  },
  {
    "id": "se",
    "name": "Sweden"
  },
  {
    "id": "ch",
    "name": "Switzerland"
  },
  {
    "id": "st",
    "name": "São Tomé and Príncipe"
  },
  {
    "id": "tw",
    "name": "Taiwan"
  },
  {
    "id": "tj",
    "name": "Tajikistan"
  },
  {
    "id": "tz",
    "name": "Tanzania"
  },
  {
    "id": "th",
    "name": "Thailand"
  },
  {
    "id": "tt",
    "name": "Trinidad and Tobago"
  },
  {
    "id": "tn",
    "name": "Tunisia"
  },
  {
    "id": "tr",
    "name": "Turkey"
  },
  {
    "id": "tm",
    "name": "Turkmenistan"
  },
  {
    "id": "tc",
    "name": "Turks and Caicos"
  },
  {
    "id": "ug",
    "name": "Uganda"
  },
  {
    "id": "ua",
    "name": "Ukraine"
  },
  {
    "id": "ae",
    "name": "United Arab Emirates"
  },
  {
    "id": "uy",
    "name": "Uruguay"
  },
  {
    "id": "uz",
    "name": "Uzbekistan"
  },
  {
    "id": "ve",
    "name": "Venezuela"
  },
  {
    "id": "vn",
    "name": "Vietnam"
  },
  {
    "id": "ye",
    "name": "Yemen"
  },
  {
    "id": "zw",
    "name": "Zimbabwe"
  }
]